import { defineMessages } from 'react-intl';
export const messages = defineMessages({
  operator: {
    defaultMessage: 'Operator',
    id: `app.containers.WorkflowEditor.components.Rules.Condition.components.ComparatorSelect.operator`,
  },
});
export default messages;
